module.exports = __webpack_public_path__ + "static/media/loading.7db18d9a.svg";